module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"damage":"Damage","kills":"Kills"},"ru":{"damage":"Урон","kills":"Убийств"}}')
  delete Component.options._Ctor
}
